module.exports = __webpack_public_path__ + "summer/img/swimming_icon.99e46fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/swimming_icon.png
// module id = HYeq
// module chunks = 39